// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    InputLabel,
    Select, TextField
} from "@mui/material";

// App Imports
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {changeLicense} from "./licenseSlice";
import {addLicense, editLicense} from "./LicenseClient";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import {getAllProducts} from "../Product/ProductClient";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import {NumericFormat} from "react-number-format";


// Main Function
export default function LicenseDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorLicenseId = useSelector((state) => state.licenseSlc.value.id);
    const selectorLicenseDrawerState = useSelector((state) => state.licenseSlc.value.licenseDrawerState);
    const selectorLicenseDrawerMode = useSelector((state) => state.licenseSlc.value.licenseDrawerMode);

    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, reset, control, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my License data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorLicenseDrawerMode==="Add"){
            addLicense(data)
                .then(() => {
                    console.log("License added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeLicense({
                    id: null, dataPointId: null, productId: null,
                    licenseStatus: null,
                    dataPointCode: null, dataPointName: null, dataType: null, dataPointStatus: null,
                    productCode:null, productName: null, category: null, productStatus: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    licenseGridRefresh: true, licenseDrawerState: false, licenseDrawerMode: null}))
            })}
        if(selectorLicenseDrawerMode==="Clone"){
            const { id, ...data } = data; // removes id
            addLicense(data)
                .then(() => {
                    console.log("License cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Cloning failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeLicense({id: null, externalId: null, amount: null, displayAmount: null, availBegin: null,
                    availEnd: null, executionDate: null, licensee: null, market: null, territory: null,
                    propertyId: null, exhibitionDays: null, runs: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    propertyName: null, initialMarket: null, genre: null, productionType: null,
                    licenseGridRefresh: true, licenseDrawerState: false, licenseDrawerMode: null}))


            })}
        if(selectorLicenseDrawerMode==="Edit"){
            console.log("This is the License Id I am going to edit")
            console.log(selectorLicenseId)
            editLicense(selectorLicenseId, data)
                .then(() => {
                    console.log("License edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeLicense({
                    licenseGridRefresh: true, licenseDrawerState: false, licenseDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeLicenseDrawer() {
        dispatchData(changeLicense({licenseDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************


    const fetchProductsForDropdown = () =>
        getAllProducts()

            .then(data => {
                console.log("Products List")
                console.log(data);
                setProducts(data);

            })
    useEffect(() => {
        console.log("This is for the products dropdown...");
        fetchProductsForDropdown();
    }, []);

// *********************** END DROPDOWNS **************************


    const license = useSelector((state) => state.licenseSlc.value);

    useEffect(() => {

        reset({
            ...license,
            availBegin: license.availBegin
                ? dayjs(license.availBegin)
                : null,

            availEnd: license.availEnd
                ? dayjs(license.availEnd)
                : null,

            executionDate: license.executionDate
                ? dayjs(license.executionDate)
                : null,

            amount: license.licenseAmount,
        });


    }, [license, reset]);

    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);



    // ****************** BEGIN FORM ****************************

    function licenseForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 800, height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={{
                        paddingLeft: 0,
                        cursor: 'pointer'
                    }} onClick={() => closeLicenseDrawer()}>License Form</h2>
                    <h4>{selectorLicenseDrawerMode} Mode</h4>
                    <TextField
                        style={{visibility: "hidden"}}
                        {...register('id', {required: true})}
                        id="id" name="id" label="id" aria-describedby="id_entry"
                        defaultValue={Number(useSelector((state) => state.licenseSlc.value.id))}
                    />
                    <br/>
                    <FormControl variant="standard" sx={{minWidth: 300}}>
                        <InputLabel htmlFor="propertyId">Property</InputLabel>
                        <Select

                            {...register('propertyId', {required: true})}
                            labelId="propertyId"
                            id="propertyId"
                            label="propertyId"
                            defaultValue={useSelector((state) => state.licenseSlc.value.propertyId)}
                            sx={{width: 600}}
                        >
                            {products.map((ProductItem) =>
                                <MenuItem value={ProductItem.id}>{ProductItem.id}: {ProductItem.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <br/>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('externalId', {required: true})}
                            id="externalId" name="externalId" label="License ID" aria-describedby="externalId_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.externalId)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('licensee', {required: true})}
                            id="licensee" name="licensee" label="Licensee" aria-describedby="licensee_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.licensee)}
                            sx={{width: 200}}/>
                        {/*<TextField*/}
                        {/*    {...register('amount', {required: true})}*/}
                        {/*    id="amount" name="amount" label="Amount" aria-describedby="amount_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.licenseSlc.value.licenseAmount)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        {/*<NumericFormat*/}
                        {/*    {...register('amount', {required: false})}*/}
                        {/*    id="amount" name="amount" label="Amount" aria-describedby="amount_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.licenseSlc.value.licenseAmount)}*/}
                        {/*    customInput={TextField}*/}
                        {/*    thousandSeparator={true}*/}
                        {/*    decimalScale={2}*/}
                        {/*    fixedDecimalScale={true}*/}
                        {/*    prefix="$"*/}
                        {/*    sx={{width: 200}}/>*/}
                        <Controller
                            name="amount"
                            control={control}
                            render={({ field }) => (
                                <NumericFormat
                                    value={field.value ?? ''}
                                    onBlur={field.onBlur}
                                    inputRef={field.ref}

                                    customInput={TextField}
                                    label="Amount"
                                    thousandSeparator
                                    decimalScale={2}
                                    fixedDecimalScale
                                    prefix="$"

                                    onValueChange={(values) => {
                                        field.onChange(values.floatValue);
                                    }}
                                />
                            )}
                        />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        {/*<TextField*/}
                        {/*    {...register('availBegin', {required: true})}*/}
                        {/*    id="availBegin" name="availBegin" label="Availability Begin"*/}
                        {/*    aria-describedby="availBeginentry"*/}
                        {/*    defaultValue={useSelector((state) => state.licenseSlc.value.availBegin)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        {/*<TextField*/}
                        {/*    {...register('availEnd', {required: true})}*/}
                        {/*    id="availEnd" name="availEnd" label="Availability End" aria-describedby="availEnd_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.licenseSlc.value.availEnd)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        {/*<TextField*/}
                        {/*    {...register('executionDate', {required: true})}*/}
                        {/*    id="executionDate" name="executionDate" label="Execution Date"*/}
                        {/*    aria-describedby="executionDate_entry"*/}
                        {/*    defaultValue={useSelector((state) => state.licenseSlc.value.executionDate)}*/}
                        {/*    sx={{width: 200}}/>*/}
                        <FormDatePicker
                            name="availBegin"
                            label="Availability Begin"
                            control={control}
                            width={260}
                            variant = "outlined"
                        />
                        <FormDatePicker
                            name="availEnd"
                            label="Availability End"
                            control={control}
                            width={260}
                            variant = "outlined"
                        />
                        <FormDatePicker
                            name="executionDate"
                            label="Execution Date"
                            control={control}
                            width={260}
                            variant = "outlined"
                        />
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('market', {required: false})}
                            id="market" name="market" label="Market" aria-describedby="market_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.licenseMarket)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('territory', {required: false})}
                            id="territory" name="territory" label="Territory" aria-describedby="territory_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.licenseTerritory)}
                            sx={{width: 200}}/>
                    </Stack>
                        <br/>
                        <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            {...register('runs', {required: false})}
                            id="runs" name="runs" label="Runs Allowed" aria-describedby="runs_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.licensedRuns)}
                            sx={{width: 200}}/>
                        <TextField
                            {...register('exhibitionDays', {required: false})}
                            id="exhibitionDays" name="exhibitionDays" label="Exhibition Days Allowed"
                            aria-describedby="exhibitionDays_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.exhibitionDays)}
                            sx={{width: 250}}/>
                        <TextField
                            {...register('status', {required: false})}
                            id="status" name="status" label="Status"
                            aria-describedby="status_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.status)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={2}>
                        <TextField
                            disabled={true}
                            TextField{...register('createdBy', {required: false})}
                            id="createdBy" name="createdBy" label="Created By"
                            aria-describedby="createdBy_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.createdBy)}
                            sx={{width: 200}}/>

                        <TextField
                            disabled={true}
                            {...register('createdOn', {required: false})}
                            id="status" name="createdOn" label="Created On"
                            aria-describedby="createdOn_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.createdOn)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedBy', {required: false})}
                            id="lastModifiedBy" name="lastModifiedBy" label="Last Modified By"
                            aria-describedby="lastModifiedBy_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.lastModifiedBy)}
                            sx={{width: 200}}/>
                        <TextField
                            disabled={true}
                            {...register('lastModifiedOn', {required: false})}
                            id="lastModifiedOn" name="lastModifiedOn" label="Last Modified On"
                            aria-describedby="lastModifiedOn_entry"
                            defaultValue={useSelector((state) => state.licenseSlc.value.lastModifiedOn)}
                            sx={{width: 200}}/>
                    </Stack>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeLicenseDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorLicenseDrawerState}
                onClose={closeLicenseDrawer}
            >
                {licenseForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
